import * as tslib_1 from "tslib";
import "../../CommonImports";
import "../../Core/core.css";
import "./FabricIcons.css";
import * as React from "react";
import { Tooltip } from '../../TooltipEx';
import { css, getSafeId } from '../../Util';
export function Icon(props) {
    if (props.render) {
        return props.render(props.className);
    }
    var icon = (React.createElement("span", { "aria-label": props.ariaLabel, "aria-labelledby": getSafeId(props.ariaLabelledBy), className: css(props.className, "flex-noshrink", props.iconName && "fabric-icon", props.iconName && "ms-Icon--" + props.iconName, props.size), id: getSafeId(props.id), key: props.key, onClick: props.onClick, onMouseDown: props.onMouseDown, style: props.style, tabIndex: props.tabIndex, title: props.title }));
    if (props.tooltipProps) {
        icon = React.createElement(Tooltip, tslib_1.__assign({}, props.tooltipProps), icon);
    }
    return icon;
}
